import { OrderedMap } from "immutable";

export function getSortedIndexes(arr, desiredLength) {
  // Get sorted indexes
  let sortedIndexes = arr
    .map((value, index) => ({ value, index }))
    .sort((a, b) => a.value - b.value)
    .map((item) => item.index);

  // Continue adding indexes in order until reaching desired length
  let i = 0;
  while (sortedIndexes.length < desiredLength) {
    if (!sortedIndexes.includes(i)) {
      sortedIndexes.push(i);
    }
    i++;
  }

  return sortedIndexes;
}

export function deepOrderedMap(obj) {
  if (Array.isArray(obj)) {
    return obj.map(deepOrderedMap);
  }
  if (obj && typeof obj === "object") {
    return OrderedMap(
      Object.entries(obj).map(([k, v]) => [k, deepOrderedMap(v)])
    );
  }
  return obj;
}
